module.exports = __webpack_public_path__ + "media/images/pokerroom/fulltilt/join-bg-bdccb2303d4364495bc172baff44d178.jpg";